export default "__VITE_ASSET__b45e6de6__"